import { WEBHOOKS_COLUMN_ID } from "../constants";
import WebhooksTableDropdownCell from "./DropdownCell";
import WebhooksTableLabelsCell from "./LabelsCell";
import WebhooksTableNameCell from "./NameCell";
import WebhooksTableSpaceCell from "./SpaceCell";
import WebhooksTableStatusCell from "./StatusCell";
import WebhooksTableTimestampCell from "./TimestampCell";

export const WEBHOOKS_TABLE_CELLS = {
  [WEBHOOKS_COLUMN_ID.NAME]: WebhooksTableNameCell,
  [WEBHOOKS_COLUMN_ID.LABELS]: WebhooksTableLabelsCell,
  [WEBHOOKS_COLUMN_ID.SPACE]: WebhooksTableSpaceCell,
  [WEBHOOKS_COLUMN_ID.STATUS]: WebhooksTableStatusCell,
  [WEBHOOKS_COLUMN_ID.CREATED_AT]: WebhooksTableTimestampCell,
  [WEBHOOKS_COLUMN_ID.DROPDOWN]: WebhooksTableDropdownCell,
};
